<template>
  <div class="modal" :class="{'is-active': active}" v-if="d">
    <div class="modal-background" @click.prevent.stop="close"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">
        <span class="picto">
            <span class="has-text-grey is-border">
                <i class="fal fa-crop"></i>
            </span>
        </span>
          Édition d'une image
        </p>
        <a @click.prevent.stop="close()" class="has-text-grey" aria-label="close">
          <i class="fal fa-times"></i>
        </a>
      </header>
      <section class="modal-card-body">
        <form @submit.prevent.stop="submit">
          <div class="columns">
            <div class="column" :class="{'cropper-circle':circle}">
              <vue-cropper :src="d.path" :drag-mode="'none'" :aspect-ratio="ratio"
                           :zoomable="false" ref="cropper"></vue-cropper>
            </div>
          </div>
          <div class="columns">
            <div class="column">
              <button @click.prevent.stop="close" class="button">Annuler</button>
              <button type="submit" class="button is-primary">Enregistrer</button>
            </div>
          </div>
        </form>
      </section>
    </div>
  </div>
</template>

<script>
  import VueCropper from 'vue-cropperjs'

  export default {
    name: 'DocumentModalEdit',
    props: {
      active: {
        type: Boolean,
        required: true
      },
      selectedDocument: {
        type: Object,
        required: true
      },
      ratio: {
        type: Number
      },
      circle: {
        type: Boolean,
        default: false
      }
    },
    components: {VueCropper},
    computed: {
      d () {
        return this.selectedDocument
      }
    },
    methods: {
      submit () {
        let cropImg = this.dataURItoBlobtoFile(this.$refs.cropper.getCroppedCanvas().toDataURL({format: 'jpeg'}))
        let newfile = new FormData()

        let name = this.d.filename
        let ext = this.d.path.split('.')
        if (!name.split('.')[name.split('.').length - 1].match(/(jpg|png|jpeg|gif)/g)) name += `.${ext[ext.length - 1]}`

        newfile.append('file[]', cropImg, name)
        newfile.cropped = true
        this.$emit('submit', newfile)
        this.$emit('close')
      },
      close () {
        this.$emit('close')
      },
      dataURItoBlobtoFile (dataURI, callback) {
        const byteString = atob(dataURI.split(',')[1])
        const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0]
        const ab = new ArrayBuffer(byteString.length)
        const ia = new Uint8Array(ab)
        for (let i = 0; i < byteString.length; i++) {
          ia[i] = byteString.charCodeAt(i)
        }
        const bb = new Blob([ab], {type: mimeString})
        const nF = new File([bb], this.d.filename, {type: mimeString})
        return nF
      }
    }
  }
</script>

<style>
.cropper-circle .cropper-view-box {
  border-radius: 50%;
}
</style>




// WEBPACK FOOTER //
// src/components/utils/DocumentModalEdit.vue